export const reviews = [
  {
    id: 1,
    name: "小漫迷阿星",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Asian%20female%20portrait%20with%20warm%20smile%20casual%20style%20soft%20natural%20lighting%20clean%20background%20professional%20headshot&width=80&height=80&seq=avatar-01&orientation=squarish",
    rating: 5,
    date: "2026-07-28",
    content: "4399漫画网真的太棒了！韩漫资源超级全，更新速度也很快，画质高清无删减，下拉式阅读体验特别流畅。推荐给了我身边所有喜欢韩漫的朋友！",
  },
  {
    id: 2,
    name: "漫画控小雨",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20gentle%20expression%20minimalist%20studio%20lighting%20clean%20neutral%20background%20professional%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish",
    rating: 5,
    date: "2026-07-25",
    content: "用了很多漫画网站，只有4399漫画网的无删减韩漫最全最完整。分类也很清晰，找漫画特别方便，界面简洁没有乱七八糟的广告。",
  },
  {
    id: 3,
    name: "韩剧迷阿泽",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%20stylish%20casual%20look%20soft%20studio%20lighting%20clean%20neutral%20background%20professional%20headshot&width=80&height=80&seq=avatar-03&orientation=squarish",
    rating: 5,
    date: "2026-07-22",
    content: "从追韩剧到追韩漫，4399漫画网的漫画画风精美程度完全不输电视剧！下拉式阅读太适合手机看了，通勤路上必刷。",
  },
  {
    id: 4,
    name: "宅漫达人CC",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20cute%20casual%20style%20warm%20expression%20soft%20natural%20light%20clean%20background%20headshot&width=80&height=80&seq=avatar-04&orientation=squarish",
    rating: 4,
    date: "2026-07-20",
    content: "免费韩漫大全名不虚传！收藏了好多喜欢的作品，更新提醒也很及时。希望以后能出APP版本就更好啦！",
  },
  {
    id: 5,
    name: "深夜读者老张",
    avatar: "https://readdy.ai/api/search-image?query=Middle%20aged%20Asian%20man%20portrait%20friendly%20expression%20casual%20clean%20studio%20lighting%20neutral%20background%20professional%20headshot&width=80&height=80&seq=avatar-05&orientation=squarish",
    rating: 5,
    date: "2026-07-18",
    content: "作为一个看了十多年漫画的老读者，4399漫画网的韩漫质量真的没话说。翻译准确，更新稳定，无删减版本看着就是过瘾。",
  },
  {
    id: 6,
    name: "甜甜圈小姐",
    avatar: "https://readdy.ai/api/search-image?query=Asian%20young%20woman%20portrait%20sweet%20smile%20elegant%20casual%20style%20soft%20studio%20light%20clean%20background%20professional%20headshot&width=80&height=80&seq=avatar-06&orientation=squarish",
    rating: 5,
    date: "2026-07-15",
    content: "恋爱类韩漫简直是我的快乐源泉！4399漫画网的推荐算法也很准，总是能给我推荐到最喜欢的类型，已经安利给全宿舍了。",
  },
];